import React from "react";
import { Layout } from "antd";
import { LeftMenu } from "../menu/LeftMenu";
import { Box } from "@mui/material";
import { AppBar } from "../appbar/AppBar";
import { styled } from "styled-components";
import { GlobalDrawer } from "../drawer/GlobalDrawer";
import { APP_NAME } from "../../constants/webapp";

export const currentYear = new Date().getFullYear();

export const DashboardContainer = ({ children }) => {
  return (
    <Layout
      hasSider
      style={{
        height: "100vh",
        width: "100%",
        position: "fixed",
      }}
    >
      <GlobalDrawer />
      <MenuWrapper>
        <LeftMenu />
      </MenuWrapper>
      <div className="x100">
        <AppBar />
        <Box
          sx={{
            p: 2,
            overflow: "auto",
            height: `calc(100% - 100px)`,
          }}
        >
          {children}
        </Box>
        <Footer />
      </div>
    </Layout>
  );
};

const Footer = () => (
  <div
    style={{ padding: 10, borderTop: "1px solid #e9e9e9" }}
    className="textCenter font12"
  >
    {`© ${currentYear} Copyright ${APP_NAME}. All Rights Reserved.`}
  </div>
);

const MenuWrapper = styled.aside`
  display: contents;
  @media (max-width: 860px) {
    display: none;
  }
`;
